import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"

function ServiceModelDetails({
  model = "", vin = "", registration = "", compact = true
}) {
  const item = styles.item(compact)
  return (
    <div style={styles.list(compact)}>
      {model && (
        <span style={item}>
          <b>Model:</b> {model}
        </span>
      )}
      {vin && (
        <span style={item}>
          <b>VIN:</b> {vin}
        </span>
      )}
      {registration && (
        <span style={item}>
          <b>Registration:</b> {registration}
        </span>
      )}
    </div>
  )
}

const styles = {
  list: compact => ({
    textAlign: "center",
    display: "flex",
    padding: "0.5em",
    justifyContent: "center",
    flexWrap: "wrap",
    alignItems: "center",
    margin: compact ? 0 : "1em 0 0",
    width: "100%",
    fontWeight: 200
  }),

  item: compact => ({
    display: "block",
    margin: ".3em .5em",
    lineHeight: 1.3,
    wordWrap: compact ? "break-word" : "normal"
  })
}

ServiceModelDetails.propTypes = {
  model: PropTypes.string,
  vin: PropTypes.string,
  registration: PropTypes.string,
  compact: PropTypes.bool
}

export default Radium(ServiceModelDetails)



// WEBPACK FOOTER //
// ./src/containers/service-model-details/index.jsx